import { useState, useEffect, useRef } from "react";
import { initializeApp } from "firebase/app";
import { getDatabase, ref, onValue, set, update } from "firebase/database";
import html2canvas from "html2canvas";

const firebaseConfig = {
  apiKey: "AIzaSyDs5mUUblDXbuod_Xfh9Cs9hJ9An7MfIcQ",
  authDomain: "worldcup-455c9.firebaseapp.com",
  databaseURL: "https://worldcup-455c9-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "worldcup-455c9",
  storageBucket: "worldcup-455c9.firebasestorage.app",
  messagingSenderId: "258857976608",
  appId: "1:258857976608:web:8d98dbe5e2f37a39a54d45"
};

const app = initializeApp(firebaseConfig);
const db = getDatabase(app);

const IS_DEV = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
const DB_PATH = IS_DEV ? "worldcup-dev" : "worldcup";

const ADMIN_PASSWORD = "admin1234";

const DEFAULT_FEMALES = ["수정 85","나나 83","샤샤 88","강이 80","나라 92","다희 85","리즈 82","미니 84","비비 87","뽀나 84","사랑 80","새로 80","소리 85","소진 89","시연 88","아진 88","여니 80","여름 94","은희 83","주리 93","주하 88","지나 90","지유 87","지효 94","채원 86","채이 90","크림 89","태리 88","하윤 81","해영 85","현영 90"];
const DEFAULT_MALES = ["민호 87","밍구 85","정수 82","건우 89","나인 88","다감 82","대포 90","덕선 85","데릭 84","라더 84","로한 88","미성 89","민국 82","새벽 84","성훈 85","수한 88","수혁 85","우준 84","은호 83","이준 90","이현 81","일우 87","장우 91","재호 92","정민 83","주혁 82","지니 80","지태 90","춘삼 85","케이 82","키달 85","덕춘 91","태기 86","푸른 85","하민 91","혜성 90"];

const COLORS = {
  pink: "#D4537E", blue: "#185FA5",
  pinkLight: "#fbeaf0", blueLight: "#e6f1fb",
  pinkDark: "#f7a8c4", blueDark: "#7bb8e8",
  pinkText: "#993556", blueText: "#0c447c",
};

function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}
function buildBracket(candidates) {
  const count = candidates.length;
  let targetSize = 2;
  while (targetSize * 2 <= count) targetSize *= 2;
  
  const excess = count - targetSize;
  const shuffled = shuffle([...candidates]);
  
  if (excess === 0) {
    return { players: shuffled, byePlayers: [], isQualifier: false };
  }
  
  const qualifierCount = excess * 2;
  const qualifierPlayers = shuffled.slice(0, qualifierCount);
  const byePlayers = shuffled.slice(qualifierCount);
  
  return { players: qualifierPlayers, byePlayers, isQualifier: true };
}
function getInitialScreen() {
  if (typeof window !== "undefined" && window.location.hash === "#admin") return "admin";
  return "home";
}
function goTo(s, setScreen) {
  window.location.hash = s === "admin" ? "admin" : "";
  setScreen(s);
}

export default function App() {
  const [state, setState] = useState({ females: DEFAULT_FEMALES, males: DEFAULT_MALES, votes: {} });
  const [loading, setLoading] = useState(true);
  const [screen, setScreen] = useState(getInitialScreen);
  const [userName, setUserName] = useState("");
  const [userGender, setUserGender] = useState(null);
  const [nameError, setNameError] = useState("");
  const [bracket, setBracket] = useState([]);
  const [byePlayers, setByePlayers] = useState([]);
  const [isQualifier, setIsQualifier] = useState(false);
  const [matchIdx, setMatchIdx] = useState(0);
  const [winners, setWinners] = useState([]);
  const [result, setResult] = useState(null);
  const [roundResults, setRoundResults] = useState({ top8: [], top4: [], top2: [], winner: null });
  const [adminPw, setAdminPw] = useState("");
  const [adminMode, setAdminMode] = useState(false);
  const [adminError, setAdminError] = useState("");
  const [editFemales, setEditFemales] = useState([]);
  const [editMales, setEditMales] = useState([]);
  const [newFemale, setNewFemale] = useState("");
  const [newMale, setNewMale] = useState("");
  const [memberTab, setMemberTab] = useState("all");
  const [rankGender, setRankGender] = useState("female");
  const [voteGender, setVoteGender] = useState("male");
  const [saving, setSaving] = useState(false);
  const resultRef = useRef(null);

  useEffect(() => {
    const dataRef = ref(db, DB_PATH);
    const unsubscribe = onValue(dataRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setState(data);
      } else {
        const initial = { females: DEFAULT_FEMALES, males: DEFAULT_MALES, votes: {} };
        set(dataRef, initial);
        setState(initial);
      }
      setLoading(false);
    });

    const handleHashChange = () => {
      if (window.location.hash === "#admin") {
        setScreen("admin");
      }
    };
    handleHashChange();
    window.addEventListener("hashchange", handleHashChange);
    
    return () => {
      unsubscribe();
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  function saveToFirebase(newState) {
    set(ref(db, DB_PATH), newState);
  }

  function getPairs(arr) {
    const pairs = [];
    for (let i = 0; i < arr.length; i += 2) pairs.push([arr[i], arr[i + 1]]);
    return pairs;
  }

  function startGame(gender) {
    const name = userName.trim();
    if (!name) { setNameError("닉네임을 입력해주세요."); return; }
    
    const getNamePart = (fullName) => fullName.split(" ")[0];
    const isInMales = state.males.some(m => getNamePart(m) === name);
    const isInFemales = state.females.some(f => getNamePart(f) === name);
    
    if (!isInMales && !isInFemales) {
      setNameError("목록에 없는 닉네임입니다. 관리자에게 문의하세요.");
      return;
    }
    if (gender === "male" && !isInMales) {
      setNameError("남성 목록에 없는 닉네임입니다.");
      return;
    }
    if (gender === "female" && !isInFemales) {
      setNameError("여성 목록에 없는 닉네임입니다.");
      return;
    }

    setUserGender(gender);
    const pool = gender === "male" ? state.females : state.males;
    const { players, byePlayers: bye, isQualifier: qual } = buildBracket(pool);
    setBracket(players);
    setByePlayers(bye);
    setIsQualifier(qual);
    setMatchIdx(0);
    setWinners([]);
    setResult(null);
    setRoundResults({ top8: [], top4: [], top2: [], winner: null });
    goTo("game", setScreen);
  }

  const allPairs = getPairs(bracket);
  const validPairs = allPairs.filter(p => p[0] && p[1]);
  const pair = validPairs[matchIdx];
  const totalRoundMatches = validPairs.length;
  const progress = totalRoundMatches > 0 ? (matchIdx / totalRoundMatches) * 100 : 0;

  function getRoundName(matchCount, isQual) {
    if (isQual) return "예선";
    if (matchCount >= 16) return "32강";
    if (matchCount >= 8) return "16강";
    if (matchCount >= 4) return "8강";
    if (matchCount >= 2) return "4강";
    if (matchCount === 1) return "결승";
    return "완료";
  }

  function choose(name) {
    const newWinners = [...winners];
    const wasAlreadySelected = winners[matchIdx] !== undefined;
    newWinners[matchIdx] = name;
    setWinners(newWinners);
    
    // 새로운 선택이고 마지막 경기가 아니면 자동으로 다음으로
    if (!wasAlreadySelected && matchIdx + 1 < validPairs.length) {
      setMatchIdx(matchIdx + 1);
    }
    // 마지막 경기에서 새 선택이면 자동으로 다음 라운드로
    else if (!wasAlreadySelected && matchIdx + 1 >= validPairs.length) {
      proceedToNextRound(newWinners);
    }
    // 이미 선택한 것을 바꾸면 그 자리에 머묾 (사용자가 다음 버튼으로 이동)
  }

  function proceedToNextRound(roundWinners) {
    if (isQualifier) {
      const mainPlayers = [...roundWinners, ...byePlayers];
      setBracket(mainPlayers);
      setByePlayers([]);
      setIsQualifier(false);
      setMatchIdx(0);
      setWinners([]);
    } else {
      if (roundWinners.length === 8) {
        setRoundResults(prev => ({ ...prev, top8: [...roundWinners] }));
      } else if (roundWinners.length === 4) {
        setRoundResults(prev => ({ ...prev, top4: [...roundWinners] }));
      } else if (roundWinners.length === 2) {
        setRoundResults(prev => ({ ...prev, top2: [...roundWinners] }));
      }
      
      if (roundWinners.length === 1) {
        finishGame(roundWinners[0]);
      } else {
        setBracket(roundWinners);
        setMatchIdx(0);
        setWinners([]);
      }
    }
  }

  function goPrevMatch() {
    if (matchIdx > 0) {
      setMatchIdx(matchIdx - 1);
    }
  }

  function goNextMatch() {
    if (matchIdx + 1 < winners.length) {
      setMatchIdx(matchIdx + 1);
    }
  }

  function finishGame(winner) {
    setResult(winner);
    setRoundResults(prev => ({ ...prev, winner }));
    const name = userName.trim();
    const newVotes = { ...(state.votes || {}) };
    newVotes[name] = {
      winner,
      gender: userGender,
      top2: roundResults.top2,
      top4: roundResults.top4,
      top8: roundResults.top8,
    };
    const next = { ...state, votes: newVotes };
    setState(next);
    saveToFirebase(next);
    goTo("result", setScreen);
  }

  async function saveResultAsImage() {
    if (!resultRef.current || saving) return;
    setSaving(true);
    try {
      const el = resultRef.current;
      const isDark = window.matchMedia?.("(prefers-color-scheme: dark)")?.matches;
      
      const clone = el.cloneNode(true);
      const rect = el.getBoundingClientRect();
      clone.style.cssText = `position: fixed; left: -9999px; top: 0; width: ${rect.width}px; background: ${isDark ? 'linear-gradient(160deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)' : 'linear-gradient(160deg, #e8eaf6 0%, #f3e5f5 50%, #e3f2fd 100%)'}; border-radius: 20px; padding: 16px;`;
      document.body.appendChild(clone);
      
      const canvas = await html2canvas(clone, {
        backgroundColor: null,
        scale: 2,
      });
      
      document.body.removeChild(clone);
      const dataUrl = canvas.toDataURL("image/png");
      
      const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      
      if (isIOS) {
        const newTab = window.open();
        if (newTab) {
          newTab.document.write(`
            <html>
              <head>
                <meta name="viewport" content="width=device-width, initial-scale=1">
                <title>썸상 월드컵 결과</title>
                <style>
                  body { margin: 0; padding: 20px; background: #f5f5f7; font-family: -apple-system, sans-serif; text-align: center; }
                  img { max-width: 100%; border-radius: 16px; box-shadow: 0 4px 20px rgba(0,0,0,0.1); }
                  p { color: #666; font-size: 14px; margin-top: 16px; }
                </style>
              </head>
              <body>
                <img src="${dataUrl}" alt="결과 이미지" />
                <p>📱 이미지를 길게 눌러서 저장하세요</p>
              </body>
            </html>
          `);
          newTab.document.close();
        }
      } else {
        const link = document.createElement("a");
        link.download = `썸상월드컵_${userName}_결과.png`;
        link.href = dataUrl;
        link.click();
      }
    } catch (e) {
      alert("이미지 저장에 실패했습니다.");
    }
    setSaving(false);
  }

  function getRankings(votes) {
    const targets = rankGender === "female" ? state.females : state.males;
    const counts = {};
    targets.forEach(n => counts[n] = 0);
    Object.values(votes || {}).forEach(data => {
      if (data && typeof data === 'object' && data.winner) {
        if (counts[data.winner] !== undefined) counts[data.winner] += 1;
      } else {
        Object.entries(data || {}).forEach(([k, val]) => {
          if (counts[k] !== undefined) counts[k] += val;
        });
      }
    });
    return Object.entries(counts).sort((a, b) => b[1] - a[1]);
  }

  function adminLogin() {
    if (adminPw === ADMIN_PASSWORD) {
      setAdminMode(true); setAdminError("");
      setEditFemales([...state.females].sort((a, b) => a.localeCompare(b, 'ko')));
      setEditMales([...state.males].sort((a, b) => a.localeCompare(b, 'ko')));
    } else setAdminError("비밀번호가 틀렸습니다.");
  }

  function saveMembers() {
    const f = [...editFemales].sort((a, b) => a.localeCompare(b, 'ko'));
    const m = [...editMales].sort((a, b) => a.localeCompare(b, 'ko'));
    const next = { ...state, females: f, males: m };
    setState(next);
    saveToFirebase(next);
    setEditFemales(f);
    setEditMales(m);
    alert("저장됐어요!");
  }

  function addMember(gender, name) {
    const trimmed = name.trim();
    if (!trimmed) return;
    if (gender === "female") {
      if (editFemales.includes(trimmed)) {
        alert("이미 있는 이름입니다.");
        return;
      }
      setEditFemales(prev => [...prev, trimmed].sort((a, b) => a.localeCompare(b, 'ko')));
      setNewFemale("");
    } else {
      if (editMales.includes(trimmed)) {
        alert("이미 있는 이름입니다.");
        return;
      }
      setEditMales(prev => [...prev, trimmed].sort((a, b) => a.localeCompare(b, 'ko')));
      setNewMale("");
    }
  }

  function removeMember(gender, name) {
    if (gender === "female") {
      setEditFemales(prev => prev.filter(n => n !== name));
    } else {
      setEditMales(prev => prev.filter(n => n !== name));
    }
  }

  function resetVotes() {
    if (!window.confirm("전체 투표를 초기화할까요?")) return;
    const next = { ...state, votes: {} };
    setState(next);
    saveToFirebase(next);
  }

  function deleteVote(voterName) {
    if (!window.confirm(`${voterName}님의 투표를 삭제할까요?`)) return;
    const newVotes = { ...(state.votes || {}) };
    delete newVotes[voterName];
    const next = { ...state, votes: newVotes };
    setState(next);
    saveToFirebase(next);
  }

  const currentRank = getRankings(state.votes);

  const css = `
    * { box-sizing: border-box; }
    .wrap { max-width: 480px; margin: 0 auto; padding: 2rem 1rem; font-family: var(--font-sans); }
    .card { background: var(--color-background-primary); border: 0.5px solid var(--color-border-tertiary); border-radius: var(--border-radius-lg); }
    .choice-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 16px; }
    .choice-card { aspect-ratio: 1/1; display: flex; flex-direction: column; align-items: center; justify-content: center; cursor: pointer; border-radius: 24px; border: 1px solid var(--color-border-tertiary); background: var(--color-background-primary); transition: border-color 0.2s, background 0.2s, transform 0.15s, box-shadow 0.2s; position: relative; overflow: hidden; box-shadow: 0 1px 4px rgba(0,0,0,0.04); }
    .choice-card:active { transform: scale(0.97); }
    @media (hover: hover) {
      .choice-card:hover { transform: translateY(-3px); box-shadow: 0 8px 24px rgba(0,0,0,0.10); }
      .choice-card.hover-m:hover { border-color: ${COLORS.blue}; background: ${COLORS.blueLight}; }
      .choice-card.hover-f:hover { border-color: ${COLORS.pink}; background: ${COLORS.pinkLight}; }
      .choice-card.hover-m:hover .name { color: ${COLORS.blueText}; }
      .choice-card.hover-f:hover .name { color: ${COLORS.pinkText}; }
    }
    .choice-card .name { font-size: clamp(16px, 4vw, 22px); font-weight: 500; color: var(--color-text-primary); }
    .pill { display: inline-flex; align-items: center; padding: 4px 12px; border-radius: 999px; font-size: 12px; font-weight: 500; }
    .tab-row { display: flex; border-bottom: 0.5px solid var(--color-border-tertiary); margin-bottom: 20px; }
    .tab-btn { padding: 10px 18px; border: none; border-bottom: 2px solid transparent; background: transparent; cursor: pointer; font-size: 14px; color: var(--color-text-secondary); }
    .tab-btn.active { font-weight: 500; color: var(--color-text-primary); border-bottom-color: var(--color-text-primary); }
    .rank-row { display: flex; align-items: center; gap: 10px; padding: 10px 0; border-bottom: 0.5px solid var(--color-border-tertiary); }
    .rank-num { font-size: 13px; font-weight: 500; min-width: 24px; color: var(--color-text-secondary); }
    .rank-num.top { color: var(--color-text-primary); }
    .rank-bar-wrap { flex: 1; height: 4px; background: var(--color-background-tertiary); border-radius: 2px; overflow: hidden; }
    .rank-bar { height: 4px; border-radius: 2px; transition: width 0.4s; }
    .rank-votes { font-size: 13px; color: var(--color-text-secondary); min-width: 32px; text-align: right; }
    .gender-toggle { display: flex; background: var(--color-background-secondary); border-radius: var(--border-radius-md); padding: 3px; gap: 2px; margin-bottom: 20px; }
    .gender-btn { flex: 1; padding: 7px; border: none; border-radius: calc(var(--border-radius-md) - 2px); cursor: pointer; font-size: 13px; font-weight: 500; background: transparent; color: var(--color-text-secondary); transition: background 0.15s, color 0.15s; }
    .gender-btn.active-f { background: ${COLORS.pink}; color: #fff; }
    .gender-btn.active-m { background: ${COLORS.blue}; color: #fff; }
    .back-btn { background: none; border: none; cursor: pointer; color: var(--color-text-secondary); padding: 0; font-size: 22px; line-height: 1; display: flex; align-items: center; }
    .section-link { background: none; border: none; cursor: pointer; font-size: 14px; color: var(--color-text-secondary); padding: 0; text-decoration: underline; text-underline-offset: 3px; }
    .progress-track { height: 3px; background: var(--color-background-tertiary); border-radius: 2px; margin-bottom: 28px; overflow: hidden; }
    .progress-fill { height: 3px; border-radius: 2px; transition: width 0.3s; }
    textarea { border: 0.5px solid var(--color-border-tertiary); border-radius: var(--border-radius-md); padding: 10px; width: 100%; resize: vertical; outline: none; background: var(--color-background-primary); color: var(--color-text-primary); font-family: var(--font-sans); font-size: 14px; }
    textarea:focus { border-color: var(--color-border-primary); }
    .loading { display: flex; align-items: center; justify-content: center; height: 100dvh; font-size: 14px; color: var(--color-text-secondary); }
    .home-bg { min-height: 100dvh; background: linear-gradient(160deg, #e8eaf6 0%, #f3e5f5 50%, #e3f2fd 100%); display: flex; align-items: center; justify-content: center; padding: 1rem; }
    .glass-card { background: rgba(255,255,255,0.4); backdrop-filter: blur(20px); -webkit-backdrop-filter: blur(20px); border-radius: 24px; border: 1px solid rgba(255,255,255,0.6); box-shadow: 0 8px 32px rgba(0,0,0,0.08); padding: 2.5rem 2rem; width: 100%; max-width: 340px; }
    .home-title { color: #37474f; font-size: 26px; font-weight: 600; text-align: center; margin: 0 0 8px; }
    .home-subtitle { color: #78909c; font-size: 14px; text-align: center; margin: 0 0 32px; }
    .home-input { width: 100%; padding: 14px 16px; border-radius: 12px; border: 1px solid rgba(0,0,0,0.08); background: rgba(255,255,255,0.6); color: #37474f; font-size: 15px; text-align: center; outline: none; transition: border-color 0.2s, box-shadow 0.2s; }
    .home-input::placeholder { color: #90a4ae; }
    .home-input:focus { border-color: #b39ddb; box-shadow: 0 0 0 3px rgba(179,157,219,0.2); }
    .home-btn { flex: 1; padding: 14px 12px; border-radius: 12px; border: none; font-size: 15px; font-weight: 500; cursor: pointer; transition: transform 0.15s, box-shadow 0.2s; }
    .home-btn:active { transform: scale(0.97); }
    .home-btn-male { background: rgba(255,255,255,0.9); color: ${COLORS.blue}; }
    .home-btn-female { background: rgba(255,255,255,0.9); color: ${COLORS.pink}; }
    @media (hover: hover) { .home-btn:hover { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(0,0,0,0.1); } }
    .home-error { color: #e53935; font-size: 13px; text-align: center; margin: 12px 0 0; background: rgba(229,57,53,0.1); padding: 10px 12px; border-radius: 8px; }
    .page-bg { min-height: 100dvh; background: linear-gradient(160deg, #e8eaf6 0%, #f3e5f5 50%, #e3f2fd 100%); padding: 1rem; }
    .page-container { max-width: 480px; margin: 0 auto; }
    .glass-panel { background: rgba(255,255,255,0.5); backdrop-filter: blur(20px); -webkit-backdrop-filter: blur(20px); border-radius: 20px; border: 1px solid rgba(255,255,255,0.6); box-shadow: 0 4px 24px rgba(0,0,0,0.06); padding: 1.5rem; margin-bottom: 16px; }
    .glass-panel-sm { background: rgba(255,255,255,0.4); backdrop-filter: blur(16px); -webkit-backdrop-filter: blur(16px); border-radius: 16px; border: 1px solid rgba(255,255,255,0.5); padding: 1rem; }
    .page-title { color: #37474f; font-size: 20px; font-weight: 600; margin: 0; }
    .page-subtitle { color: #78909c; font-size: 13px; }
    .glass-input { width: 100%; padding: 12px 14px; border-radius: 10px; border: 1px solid rgba(0,0,0,0.08); background: rgba(255,255,255,0.6); color: #37474f; font-size: 14px; outline: none; }
    .glass-input:focus { border-color: #b39ddb; box-shadow: 0 0 0 3px rgba(179,157,219,0.15); }
    .glass-btn { padding: 12px 20px; border-radius: 12px; border: none; font-size: 14px; font-weight: 500; cursor: pointer; transition: transform 0.15s, box-shadow 0.2s; background: #fff; color: #37474f; }
    .glass-btn:active { transform: scale(0.97); }
    .glass-btn-primary { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: #fff; }
    .glass-btn-danger { background: rgba(229,57,53,0.1); color: #e53935; border: 1px solid rgba(229,57,53,0.2); }
    @media (hover: hover) { .glass-btn:hover { transform: translateY(-2px); box-shadow: 0 6px 20px rgba(0,0,0,0.1); } }
    .glass-choice { aspect-ratio: 1/1; display: flex; flex-direction: column; align-items: center; justify-content: center; cursor: pointer; border-radius: 20px; background: rgba(255,255,255,0.5); backdrop-filter: blur(12px); border: 1px solid rgba(255,255,255,0.6); transition: transform 0.15s, box-shadow 0.2s, background 0.2s; }
    .glass-choice.selected { background: rgba(255,255,255,0.7); }
    .glass-choice:active { transform: scale(0.97); }
    @media (hover: hover) { .glass-choice:hover { transform: translateY(-4px); box-shadow: 0 12px 32px rgba(0,0,0,0.12); background: rgba(255,255,255,0.7); } }
    .glass-choice .name { font-size: clamp(16px, 4vw, 20px); font-weight: 500; color: #37474f; }
    .glass-pill { display: inline-flex; align-items: center; padding: 6px 12px; border-radius: 999px; font-size: 12px; font-weight: 500; background: rgba(255,255,255,0.6); color: #546e7a; }
    .result-capture { background: transparent; padding: 0; }
    .result-panel { background: rgba(255,255,255,0.5); backdrop-filter: blur(20px); -webkit-backdrop-filter: blur(20px); border-radius: 20px; border: 1px solid rgba(255,255,255,0.6); box-shadow: 0 4px 24px rgba(0,0,0,0.06); padding: 1.5rem; margin-bottom: 16px; }
    .result-subtext { color: #78909c; }
    .result-winner-box { background: rgba(255,255,255,0.6); border-radius: 16px; padding: 1.5rem; margin-top: 16px; }
    .result-winner-name { font-size: 26px; font-weight: 600; color: #37474f; }
    .result-label { font-size: 13px; font-weight: 500; color: #546e7a; margin-bottom: 8px; }
    .result-pill { display: inline-flex; align-items: center; padding: 6px 12px; border-radius: 999px; font-size: 12px; font-weight: 500; background: rgba(255,255,255,0.6); color: #546e7a; }
    .glass-textarea { width: 100%; padding: 10px 12px; border-radius: 10px; border: 1px solid rgba(0,0,0,0.08); background: rgba(255,255,255,0.6); color: #37474f; font-size: 13px; resize: vertical; outline: none; font-family: inherit; }
    .glass-textarea:focus { border-color: #b39ddb; }
    .game-round { font-size: 14px; font-weight: 600; color: #37474f; }
    .game-progress { font-size: 13px; color: #78909c; }
    .game-hint { text-align: center; font-size: 13px; color: #78909c; margin: 0 0 20px; }
    .game-nav-btn { padding: 8px 16px; border-radius: 8px; border: none; background: rgba(0,0,0,0.08); color: #37474f; cursor: pointer; font-size: 13px; transition: background 0.15s; }
    .game-nav-btn:hover { background: rgba(0,0,0,0.12); }
    .game-nav-btn:disabled { background: transparent; color: transparent; cursor: default; }
    .admin-back { background: none; border: none; cursor: pointer; font-size: 20px; color: #546e7a; padding: 0; }
    .admin-label { font-size: 14px; font-weight: 600; color: #37474f; margin: 0 0 10px; }
    .admin-stat { font-size: 14px; color: #546e7a; background: rgba(255,255,255,0.5); padding: 6px 12px; border-radius: 8px; }
    .admin-voter { font-weight: 600; min-width: 50px; color: #37474f; }
    .admin-arrow { color: #90a4ae; font-size: 12px; }
    .admin-sub { color: #78909c; font-size: 12px; }
    .admin-sublabel { color: #90a4ae; font-size: 11px; }
    .admin-toggle-wrap { display: flex; background: rgba(0,0,0,0.04); border-radius: 10px; padding: 3px; margin-bottom: 16px; }
    .admin-toggle-btn { flex: 1; padding: 8px; border: none; border-radius: 8px; cursor: pointer; font-size: 13px; font-weight: 500; background: transparent; color: #78909c; }
    .admin-toggle-btn.active-f { background: ${COLORS.pink}; color: #fff; }
    .admin-toggle-btn.active-m { background: ${COLORS.blue}; color: #fff; }
    .admin-tab { padding: 8px 16px; border: none; border-radius: 8px; cursor: pointer; font-size: 13px; font-weight: 500; background: transparent; color: #90a4ae; }
    .admin-tab.active { background: rgba(255,255,255,0.8); color: #37474f; }
    .admin-history-btn { padding: 6px 14px; border-radius: 999px; border: none; background: rgba(255,255,255,0.6); color: #78909c; cursor: pointer; font-size: 13px; }
    .admin-history-btn.active { background: #37474f; color: #fff; font-weight: 500; }
    .admin-rank-row { display: flex; align-items: center; gap: 10px; padding: 10px 0; border-bottom: 1px solid rgba(0,0,0,0.04); }
    .admin-rank-num { font-size: 13px; font-weight: 600; min-width: 24px; color: #90a4ae; }
    .admin-rank-num.top { color: #37474f; }
    .admin-rank-name { font-size: 14px; color: #37474f; min-width: 80px; }
    .admin-rank-name.top { font-weight: 600; }
    .admin-rank-bar-wrap { flex: 1; height: 6px; background: rgba(0,0,0,0.04); border-radius: 3px; overflow: hidden; }
    .admin-rank-bar { height: 6px; border-radius: 3px; background: #b0bec5; transition: width 0.4s; }
    .admin-rank-votes { font-size: 13px; color: #78909c; min-width: 36px; text-align: right; }
    .member-tag { display: inline-flex; align-items: center; gap: 4px; padding: 5px 8px 5px 10px; border-radius: 16px; font-size: 13px; background: rgba(0,0,0,0.06); color: #37474f; }
    .member-tag-remove { background: none; border: none; cursor: pointer; font-size: 14px; color: #78909c; padding: 0; line-height: 1; }
    .member-tag-remove:hover { color: #e53935; }
    
    @media (prefers-color-scheme: dark) {
      .home-bg, .page-bg { background: linear-gradient(160deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%); }
      .glass-card { background: rgba(255,255,255,0.08); border: 1px solid rgba(255,255,255,0.1); box-shadow: 0 8px 32px rgba(0,0,0,0.3); }
      .glass-panel { background: rgba(255,255,255,0.08); border: 1px solid rgba(255,255,255,0.1); box-shadow: 0 4px 24px rgba(0,0,0,0.2); }
      .home-title, .page-title { color: #f0f0f0; }
      .home-subtitle, .page-subtitle { color: rgba(255,255,255,0.6); }
      .home-input, .glass-input { background: rgba(255,255,255,0.1); border: 1px solid rgba(255,255,255,0.15); color: #f0f0f0; }
      .home-input::placeholder, .glass-input::placeholder { color: rgba(255,255,255,0.4); }
      .home-input:focus, .glass-input:focus { border-color: rgba(255,255,255,0.3); box-shadow: 0 0 0 3px rgba(255,255,255,0.1); }
      .home-btn, .glass-btn { background: rgba(255,255,255,0.15); color: #f0f0f0; }
      .home-btn-male { background: rgba(24,95,165,0.4); color: #8bb8e8; }
      .home-btn-female { background: rgba(212,83,126,0.4); color: #f0a0bc; }
      .home-error { background: rgba(239,68,68,0.2); color: #fca5a5; }
      .glass-choice { background: rgba(255,255,255,0.08); border: 1px solid rgba(255,255,255,0.1); }
      .glass-choice.selected { background: rgba(255,255,255,0.2); }
      .glass-choice .name { color: #f0f0f0; }
      .glass-pill { background: rgba(255,255,255,0.1); color: rgba(255,255,255,0.8); }
      .glass-textarea { background: rgba(255,255,255,0.1); border: 1px solid rgba(255,255,255,0.15); color: #f0f0f0; }
      .glass-btn-danger { background: rgba(239,68,68,0.2); color: #fca5a5; border: 1px solid rgba(239,68,68,0.3); }
      .game-round { color: #f0f0f0; }
      .game-progress { color: rgba(255,255,255,0.6); }
      .game-hint { color: rgba(255,255,255,0.6); }
      .game-nav-btn { background: rgba(255,255,255,0.15); color: rgba(255,255,255,0.8); }
      .admin-back { color: rgba(255,255,255,0.7); }
      .admin-label { color: #f0f0f0; }
      .admin-stat { color: rgba(255,255,255,0.8); background: rgba(255,255,255,0.1); }
      .admin-voter { color: #f0f0f0; }
      .admin-arrow { color: rgba(255,255,255,0.4); }
      .admin-sub { color: rgba(255,255,255,0.6); }
      .admin-sublabel { color: rgba(255,255,255,0.4); }
      .admin-toggle-wrap { background: rgba(255,255,255,0.08); }
      .admin-toggle-btn { color: rgba(255,255,255,0.5); }
      .admin-tab { color: rgba(255,255,255,0.4); }
      .admin-tab.active { background: rgba(255,255,255,0.15); color: #f0f0f0; }
      .admin-history-btn { background: rgba(255,255,255,0.1); color: rgba(255,255,255,0.6); }
      .admin-history-btn.active { background: #f0f0f0; color: #1a1a2e; }
      .admin-rank-row { border-bottom-color: rgba(255,255,255,0.06); }
      .admin-rank-num { color: rgba(255,255,255,0.4); }
      .admin-rank-num.top { color: #f0f0f0; }
      .admin-rank-name { color: rgba(255,255,255,0.8); }
      .admin-rank-name.top { color: #f0f0f0; }
      .admin-rank-bar-wrap { background: rgba(255,255,255,0.08); }
      .admin-rank-bar { background: rgba(255,255,255,0.3); }
      .admin-rank-votes { color: rgba(255,255,255,0.5); }
      .member-tag { background: rgba(255,255,255,0.1); color: #f0f0f0; }
      .member-tag-remove { color: rgba(255,255,255,0.5); }
      .member-tag-remove:hover { color: #f87171; }
      .result-capture { background: transparent; }
      .result-panel { background: rgba(255,255,255,0.08); border: 1px solid rgba(255,255,255,0.1); box-shadow: 0 4px 24px rgba(0,0,0,0.2); }
      .result-subtext { color: rgba(255,255,255,0.6); }
      .result-winner-box { background: rgba(255,255,255,0.1); }
      .result-winner-name { color: #f0f0f0; }
      .result-label { color: rgba(255,255,255,0.6); }
      .result-pill { background: rgba(255,255,255,0.1); color: rgba(255,255,255,0.8); }
      @media (hover: hover) { 
        .glass-choice:hover { background: rgba(255,255,255,0.15); box-shadow: 0 12px 32px rgba(0,0,0,0.3); }
        .home-btn:hover, .glass-btn:hover { box-shadow: 0 6px 20px rgba(0,0,0,0.3); }
      }
    }
  `;

  if (loading) return (
    <>
      <style>{css}</style>
      <div className="loading">로딩 중...</div>
    </>
  );

  if (screen === "home") return (
    <>
      <style>{css}</style>
      <div className="home-bg">
        <div className="glass-card">
          <h1 className="home-title">썸상 월드컵</h1>
          <p className="home-subtitle">나의 썸상을 찾아보세요</p>
          
          <input 
            className="home-input"
            value={userName} 
            onChange={e => { setUserName(e.target.value); setNameError(""); }} 
            onKeyDown={e => e.key === "Enter" && userName.trim() && startGame("male")} 
            placeholder="닉네임을 입력하세요"
          />
          {nameError && <p className="home-error">{nameError}</p>}
          
          <div style={{ display: "flex", gap: 12, marginTop: 24 }}>
            <button className="home-btn home-btn-male" onClick={() => startGame("male")}>
              👦🏻 남성
            </button>
            <button className="home-btn home-btn-female" onClick={() => startGame("female")}>
              👧🏻 여성
            </button>
          </div>
        </div>
      </div>
    </>
  );

  if (screen === "game" && pair) {
    const isMale = userGender === "male";
    const isDark = window.matchMedia?.("(prefers-color-scheme: dark)")?.matches;
    const accentColor = isMale 
      ? (isDark ? COLORS.blueDark : COLORS.blue) 
      : (isDark ? COLORS.pinkDark : COLORS.pink);
    const roundName = getRoundName(totalRoundMatches, isQualifier);
    const currentSelection = winners[matchIdx];
    const canGoPrev = matchIdx > 0;
    const canGoNext = matchIdx + 1 < winners.length;
    const isLastMatch = matchIdx + 1 >= validPairs.length;
    const allSelected = winners.length === validPairs.length;
    const canProceed = isLastMatch && allSelected;
    const canGoToNewMatch = currentSelection && matchIdx === winners.length - 1 && matchIdx + 1 < validPairs.length;
    
    return (
      <>
        <style>{css}</style>
        <div className="page-bg" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ width: "100%", maxWidth: 400 }}>
            <div className="glass-panel">
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
                <span className="game-round">{roundName}</span>
                <span className="game-progress">{matchIdx + 1} / {totalRoundMatches}</span>
              </div>
              <div style={{ height: 4, background: "rgba(0,0,0,0.06)", borderRadius: 2, marginBottom: 20, overflow: "hidden" }}>
                <div style={{ height: 4, borderRadius: 2, width: `${progress}%`, background: accentColor, transition: "width 0.3s" }} />
              </div>
              <p className="game-hint">
                {currentSelection ? `현재 선택: ${currentSelection}` : "더 끌리는 사람을 선택하세요"}
              </p>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                {[pair[0], pair[1]].map(name => (
                  <div 
                    key={name} 
                    className={`glass-choice${currentSelection === name ? " selected" : ""}`}
                    onClick={() => choose(name)}
                    style={currentSelection === name ? { border: `2px solid ${accentColor}` } : {}}
                  >
                    <div className="name">{name}</div>
                    {currentSelection === name && <div style={{ fontSize: 12, color: accentColor, marginTop: 4 }}>✓ 선택됨</div>}
                  </div>
                ))}
              </div>
              
              <div style={{ display: "flex", justifyContent: "space-between", marginTop: 16 }}>
                <button className="game-nav-btn" onClick={goPrevMatch} disabled={!canGoPrev}>
                  ← 이전
                </button>
                {canGoNext && (
                  <button className="game-nav-btn" onClick={goNextMatch}>
                    다음 →
                  </button>
                )}
                {canGoToNewMatch && (
                  <button className="game-nav-btn" onClick={() => setMatchIdx(matchIdx + 1)} style={{ background: accentColor, color: "#fff" }}>
                    다음 문제 →
                  </button>
                )}
                {canProceed && (
                  <button className="game-nav-btn" onClick={() => proceedToNextRound(winners)} style={{ background: accentColor, color: "#fff" }}>
                    {validPairs.length === 1 ? "결과 보기 →" : "다음 라운드 →"}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  if (screen === "result") {
    const isMale = userGender === "male";
    const isDark = window.matchMedia?.("(prefers-color-scheme: dark)")?.matches;
    const accentColor = isMale 
      ? (isDark ? COLORS.blueDark : COLORS.blue) 
      : (isDark ? COLORS.pinkDark : COLORS.pink);
    return (
      <>
        <style>{css}</style>
        <div className="page-bg" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ width: "100%", maxWidth: 380 }}>
            <div ref={resultRef} className="result-capture">
              <div className="result-panel" style={{ textAlign: "center" }}>
                <div style={{ fontSize: 52, marginBottom: 12 }}>🏆</div>
                <p className="result-subtext" style={{ margin: "0 0 6px", fontSize: 13 }}>{userName}님의 최종 썸상</p>
                <div className="result-winner-box" style={{ border: `2px solid ${accentColor}` }}>
                  <div className="result-winner-name">{result}</div>
                </div>
              </div>
              
              {(roundResults.top2.length > 0 || roundResults.top4.length > 0 || roundResults.top8.length > 0) && (
                <div className="result-panel">
                  {roundResults.top2.length > 0 && (
                    <div style={{ marginBottom: 16 }}>
                      <p className="result-label">🥈 결승 진출</p>
                      <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                        {roundResults.top2.map(n => <span key={n} className="result-pill">{n}</span>)}
                      </div>
                    </div>
                  )}
                  {roundResults.top4.length > 0 && (
                    <div style={{ marginBottom: 16 }}>
                      <p className="result-label">🥉 4강 진출</p>
                      <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                        {roundResults.top4.map(n => <span key={n} className="result-pill">{n}</span>)}
                      </div>
                    </div>
                  )}
                  {roundResults.top8.length > 0 && (
                    <div>
                      <p className="result-label">8강 진출</p>
                      <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                        {roundResults.top8.map(n => <span key={n} className="result-pill">{n}</span>)}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
            
            <div style={{ display: "flex", gap: 8, marginTop: 16 }}>
              <button className="glass-btn" onClick={saveResultAsImage} disabled={saving} style={{ flex: 1, padding: 14 }}>
                {saving ? "저장 중..." : "📷 이미지 저장"}
              </button>
              <button className="glass-btn glass-btn-primary" onClick={() => { goTo("home", setScreen); setUserGender(null); }} style={{ flex: 1, padding: 14 }}>다시 투표하기</button>
            </div>
          </div>
        </div>
      </>
    );
  }

  if (screen === "admin") {
    if (!adminMode) return (
      <>
        <style>{css}</style>
        <div className="home-bg">
          <div className="glass-card">
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 24 }}>
              <button className="admin-back" onClick={() => goTo("home", setScreen)}>←</button>
              <h2 className="home-title" style={{ fontSize: 20, margin: 0 }}>관리자</h2>
            </div>
            <input 
              className="home-input" 
              type="password" 
              value={adminPw} 
              onChange={e => setAdminPw(e.target.value)} 
              onKeyDown={e => e.key === "Enter" && adminLogin()} 
              placeholder="비밀번호 입력" 
            />
            {adminError && <p className="home-error">{adminError}</p>}
            <button className="glass-btn glass-btn-primary" onClick={adminLogin} style={{ width: "100%", marginTop: 20, padding: 14 }}>로그인</button>
          </div>
        </div>
      </>
    );

    return (
      <>
        <style>{css}</style>
        <div className="page-bg">
          <div className="page-container">
            <div className="glass-panel" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <button className="admin-back" onClick={() => { goTo("home", setScreen); setAdminMode(false); setAdminPw(""); }}>←</button>
                <h2 className="page-title">관리자</h2>
              </div>
              <span className="admin-stat">참여자 <strong>{Object.keys(state.votes || {}).length}</strong>명</span>
            </div>

            {Object.keys(state.votes || {}).length > 0 && (() => {
              const getNamePart = (fullName) => fullName.split(" ")[0];
              const maleVoters = Object.entries(state.votes).filter(([voter, data]) => {
                if (data && data.gender) return data.gender === "male";
                return state.males.some(m => getNamePart(m) === voter);
              });
              const femaleVoters = Object.entries(state.votes).filter(([voter, data]) => {
                if (data && data.gender) return data.gender === "female";
                return state.females.some(f => getNamePart(f) === voter);
              });
              const currentVoters = voteGender === "male" ? maleVoters : femaleVoters;
              
              return (
                <div className="glass-panel">
                  <p className="admin-label" style={{ marginBottom: 12 }}>투표 내역</p>
                  <div className="admin-toggle-wrap" style={{ marginBottom: 16 }}>
                    <button onClick={() => setVoteGender("male")} className={`admin-toggle-btn ${voteGender === "male" ? "active-m" : ""}`}>👦🏻 남성 ({maleVoters.length})</button>
                    <button onClick={() => setVoteGender("female")} className={`admin-toggle-btn ${voteGender === "female" ? "active-f" : ""}`}>👧🏻 여성 ({femaleVoters.length})</button>
                  </div>
                  {currentVoters.length === 0 ? (
                    <p className="admin-sublabel" style={{ fontSize: 13, textAlign: "center", padding: "1rem 0" }}>아직 투표가 없어요</p>
                  ) : currentVoters.map(([voter, data]) => {
                    const isNewFormat = data && typeof data === 'object' && data.winner;
                    const winner = isNewFormat ? data.winner : Object.keys(data)[0];
                    const top2 = isNewFormat ? (data.top2 || []) : [];
                    const top4 = isNewFormat ? (data.top4 || []) : [];
                    const isFemale = state.females.some(f => f === winner || f.startsWith(winner?.split(' ')[0]));
                    return (
                      <div key={voter} style={{ padding: "10px 0", borderBottom: "1px solid rgba(0,0,0,0.06)", fontSize: 13 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
                          <span className="admin-voter">{voter}</span>
                          <span className="admin-arrow">→</span>
                          <span className="glass-pill" style={{ background: isFemale ? COLORS.pinkLight : COLORS.blueLight, color: isFemale ? COLORS.pinkText : COLORS.blueText }}>
                            🏆 {winner}
                          </span>
                          <button onClick={() => deleteVote(voter)} style={{ marginLeft: "auto", background: "rgba(229,57,53,0.1)", border: "none", borderRadius: 6, cursor: "pointer", color: "#e53935", fontSize: 12, padding: "4px 8px" }}>삭제</button>
                        </div>
                        {top2.length > 0 && (
                          <div style={{ display: "flex", alignItems: "center", gap: 6, marginLeft: 58, marginBottom: 2 }}>
                            <span className="admin-sublabel">결승:</span>
                            {top2.map(n => <span key={n} className="admin-sub">{n}</span>)}
                          </div>
                        )}
                        {top4.length > 0 && (
                          <div style={{ display: "flex", alignItems: "center", gap: 6, marginLeft: 58 }}>
                            <span className="admin-sublabel">4강:</span>
                            {top4.map(n => <span key={n} className="admin-sub">{n}</span>)}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              );
            })()}

            <div className="glass-panel" style={{ marginBottom: 16 }}>
              <div className="admin-toggle-wrap" style={{ marginBottom: 12 }}>
                <button onClick={() => setMemberTab("all")} className={`admin-toggle-btn ${memberTab === "all" ? "active-f" : ""}`}>전체 ({editFemales.length + editMales.length})</button>
                <button onClick={() => setMemberTab("female")} className={`admin-toggle-btn ${memberTab === "female" ? "active-f" : ""}`}>여성 ({editFemales.length})</button>
                <button onClick={() => setMemberTab("male")} className={`admin-toggle-btn ${memberTab === "male" ? "active-m" : ""}`}>남성 ({editMales.length})</button>
              </div>

              {memberTab === "all" && (
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 4, maxHeight: 300, overflowY: "auto" }}>
                  {[...editFemales.map(n => ({ name: n, gender: "female" })), ...editMales.map(n => ({ name: n, gender: "male" }))]
                    .sort((a, b) => a.name.localeCompare(b.name, 'ko'))
                    .map(({ name, gender }) => (
                      <span key={`${gender}-${name}`} className="member-tag" style={{ background: gender === "female" ? "rgba(212,83,126,0.15)" : "rgba(24,95,165,0.15)" }}>
                        {name}
                        <button onClick={() => removeMember(gender, name)} className="member-tag-remove">×</button>
                      </span>
                    ))}
                </div>
              )}

              {memberTab === "female" && (
                <div>
                  <div style={{ display: "flex", gap: 6, marginBottom: 10 }}>
                    <input 
                      className="glass-input" 
                      value={newFemale} 
                      onChange={e => setNewFemale(e.target.value)}
                      onKeyDown={e => e.key === "Enter" && addMember("female", newFemale)}
                      placeholder="이름 입력"
                      style={{ flex: 1, padding: "8px 10px", fontSize: 13 }}
                    />
                    <button className="glass-btn" onClick={() => addMember("female", newFemale)} style={{ padding: "8px 12px", fontSize: 13 }}>추가</button>
                  </div>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 6, maxHeight: 160, overflowY: "auto" }}>
                    {editFemales.map(name => (
                      <span key={name} className="member-tag">
                        {name}
                        <button onClick={() => removeMember("female", name)} className="member-tag-remove">×</button>
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {memberTab === "male" && (
                <div>
                  <div style={{ display: "flex", gap: 6, marginBottom: 10 }}>
                    <input 
                      className="glass-input" 
                      value={newMale} 
                      onChange={e => setNewMale(e.target.value)}
                      onKeyDown={e => e.key === "Enter" && addMember("male", newMale)}
                      placeholder="이름 입력"
                      style={{ flex: 1, padding: "8px 10px", fontSize: 13 }}
                    />
                    <button className="glass-btn" onClick={() => addMember("male", newMale)} style={{ padding: "8px 12px", fontSize: 13 }}>추가</button>
                  </div>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 6, maxHeight: 160, overflowY: "auto" }}>
                    {editMales.map(name => (
                      <span key={name} className="member-tag">
                        {name}
                        <button onClick={() => removeMember("male", name)} className="member-tag-remove">×</button>
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <button className="glass-btn glass-btn-primary" onClick={saveMembers} style={{ width: "100%", padding: 14, marginBottom: 8 }}>멤버 저장</button>
            <button className="glass-btn glass-btn-danger" onClick={resetVotes} style={{ width: "100%", padding: 12, marginBottom: 24 }}>전체 투표 초기화</button>
            
            <div className="glass-panel">
              <h3 className="admin-label" style={{ fontSize: 17, marginBottom: 16 }}>인기 순위</h3>
              <div className="admin-toggle-wrap">
                <button onClick={() => setRankGender("female")} className={`admin-toggle-btn ${rankGender === "female" ? "active-f" : ""}`}>여성 순위</button>
                <button onClick={() => setRankGender("male")} className={`admin-toggle-btn ${rankGender === "male" ? "active-m" : ""}`}>남성 순위</button>
              </div>
              {(() => {
                const rank = currentRank;
                const maxVotes = Math.max(...rank.map(r => r[1]), 1);
                const barColor = rankGender === "female" ? COLORS.pink : COLORS.blue;
                return rank.every(r => r[1] === 0)
                  ? <p className="admin-sublabel" style={{ textAlign: "center", fontSize: 14, padding: "2rem 0" }}>아직 투표 데이터가 없어요</p>
                  : rank.slice(0, 15).map(([name, count], i) => (
                    <div key={name} className="admin-rank-row">
                      <span className={`admin-rank-num ${i < 3 ? "top" : ""}`}>{i + 1}</span>
                      <span className={`admin-rank-name ${i < 3 ? "top" : ""}`}>{name}</span>
                      <div className="admin-rank-bar-wrap">
                        <div className="admin-rank-bar" style={{ width: `${(count / maxVotes) * 100}%`, background: i === 0 ? barColor : undefined }} />
                      </div>
                      <span className="admin-rank-votes">{count}표</span>
                    </div>
                  ));
              })()}
            </div>
          </div>
        </div>
      </>
    );
  }

  return null;
}
